import { useQuery } from '@tanstack/react-query';
import { DepotDto, fetchDepots } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useDepots = (args?: {
  page?: number;
  perPage?: number;
  searchTerm?: string;
  sortingExpressions?: string;
}) =>
  useQuery({
    queryFn: async () => {
      const response = await extractData(
        fetchDepots({
          query: {
            PageNumber: (args?.page ?? 0) + 1, // API uses 1-based pages, convert from 0-based
            PageSize: args?.perPage ?? 20,
            SearchTerm: args?.searchTerm ?? null,
            SortingExpressions: args?.sortingExpressions ?? null,
          },
        })
      );

      const data = (response.page?.items || []) as Array<
        DepotDto & { id: number }
      >;
      const totalCount = response.page?.totalItemCount ?? 0;

      return {
        data,
        totalCount,
      };
    },
    queryKey: [
      'depots',
      args?.page,
      args?.perPage,
      args?.searchTerm,
      args?.sortingExpressions,
    ],
  });
